/**
 * Venda FORA SUL (cliente fora de RS, SC e PR) paga METADE do percentual da
 * produtividade — para todo cargo (Douglas 26/09/2026). A venda continua
 * inteira no faturamento, na faixa e na meta. O sinal `fora_sul` de cada item
 * vem de v_planilha_mae_comissao.
 */
export const FATOR_COMISSAO_FORA_SUL = 0.5;
